export const getSelectedNav = ({ selectedNav }) => selectedNav;

export const getSelectedEduNav = ({ selectedEduNav }) => selectedEduNav;
